/**
 * Іконка типу заходу — на бейджі картки (EventCard) і в міні-гайді над
 * календарем (Calendar.jsx). Свої іконки, а не з бібліотеки: типів мало
 * (Змагання, Збори, Професійне навчання), і кожен вже описаний текстовою міткою
 * поруч — іконка лише прискорює візуальне розпізнавання.
 */
const TYPE_ICON_PATHS = {
  // Медаль: коло й дві стрічки — змагання.
  Змагання: (
    <>
      <circle cx='12' cy='8' r='5' fill='none' stroke='currentColor' strokeWidth='1.6' />
      <path
        d='M8.4 12.6 6.5 20.5 12 17.3l5.5 3.2-1.9-7.9'
        fill='none'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </>
  ),
  // Дві голови — збори, спільна присутність.
  Збори: (
    <>
      <circle cx='8.5' cy='8.5' r='3' fill='none' stroke='currentColor' strokeWidth='1.6' />
      <path d='M3.5 19c0-3 2.3-5.2 5-5.2s5 2.2 5 5.2' fill='none' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round' />
      <circle cx='16.2' cy='7.3' r='2.3' fill='none' stroke='currentColor' strokeWidth='1.6' />
      <path d='M14.3 12.3c2.5-.2 4.9 1.6 5.2 4.4' fill='none' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round' />
    </>
  ),
  // Розгорнута книга — професійне навчання.
  'Професійне навчання': (
    <>
      <path
        d='M12 7c-1.9-1.1-4.3-1.5-6.5-1.1v10.6c2.2-.4 4.6 0 6.5 1.1 1.9-1.1 4.3-1.5 6.5-1.1V5.9C16.3 5.5 13.9 5.9 12 7Z'
        fill='none'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M12 7v10.6' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round' />
    </>
  ),
};

/** Крапка замість конкретної іконки — на випадок типу, якого тут ще не описано. */
const DEFAULT_TYPE_ICON = <circle cx='12' cy='12' r='4.5' fill='none' stroke='currentColor' strokeWidth='1.6' />;

export default function EventTypeIcon({ type, size = 16 }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' aria-hidden='true'>
      {TYPE_ICON_PATHS[type] || DEFAULT_TYPE_ICON}
    </svg>
  );
}
